<div class="expansion-panel" [class.expanded]="expanded()">
  <div class="expansion-panel-header display-flex align-items-center">
    <ng-container>
      <div
        class="icon-wrapper display-flex align-items-center justify-content-center mr-12"
        [ngClass]="
          expanded() && activeIconWrapperBgClass()
            ? activeIconWrapperBgClass()
            : defaultIconWrapperBgClass()
        "
      >
        <mat-icon
          [svgIcon]="
            expanded() && activeIconName()
              ? activeIconName()
              : defaultIconName()
          "
          [ngClass]="
            expanded() && activeIconColorClass()
              ? activeIconColorClass()
              : defaultIconColorClass()
          "
        ></mat-icon>
      </div>
    </ng-container>

    @if (titleTemplate()) {
      <ng-container [ngTemplateOutlet]="titleTemplate()"></ng-container>
    }

    <div class="right-part display-flex align-items-center">
      @if (metaTextTemplate()) {
        <div class="mr-8">
          <ng-container [ngTemplateOutlet]="metaTextTemplate()"></ng-container>
        </div>
      }

      <button
        (click)="toggle()"
        [disabled]="disabled()"
        [class.expanded]="expanded()"
        class="toggle-button"
        mat-icon-button
      >
        <mat-icon
          svgIcon="twc:caret"
          class="twc-stroke-secondary-typeface"
        ></mat-icon>
      </button>
    </div>
  </div>

  <div
    class="content-wrapper"
    role="region"
    [attr.inert]="!expanded() ? '' : null"
    [attr.aria-hidden]="!expanded()"
  >
    <div class="content">
      <div class="content-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
